import React, { ReactElement } from 'react';
import classNames from 'classnames';
import DocumentSetSwitchSC from 'components/pages/documents/DocumentSetSwitch.styled';
import { DocSetEnum } from 'components/pages/documents/documents.data';

export interface DocSetOption {
    value: DocSetEnum;
    label: string;
    count: number;
    /** jazyk popisku — aby čtečka přečetla „Documents in English“ anglicky */
    lang: string;
}

interface Props {
    options: DocSetOption[];
    value: DocSetEnum;
    /** přístupný název skupiny, česky (jazyk stránky) */
    groupLabel: string;
    onChange: (value: DocSetEnum) => void;
    className?: string;
}

/*
    Přepínač SADY dokumentů (souborů ke stažení), NIKOLI jazyka aplikace.

    Záměrně NEpoužívá components/filters/SubSubMenuFilter, i když vypadá stejně:
      1. renderuje volby jako <div onClick> (SubSubMenuFilter.tsx:31-40) — nefokusovatelné,
         bez Enter/Space, bez oznámení stavu,
      2. na řádku 38 žene popisek přes t(), tedy zachází s ním jako s překladovým klíčem,
      3. je sdílený s filtrovacím enginem (FilterInput.tsx) a dashboardem — změna jeho
         výchozího renderu je regrese na cizích obrazovkách.
    Vizuál se proto dědí přes styled(SubSubMenuSC), sémantiku vlastní tato komponenta.

    role="group" + aria-pressed (ne radiogroup): dvě nativní <button> mají Tab, Enter
    i Space zdarma. Polovičatý radiogroup bez roving tabindexu je horší než korektní
    dvojice tlačítek a v repu není jediný precedens roving tabindexu.
 */
const DocumentSetSwitch = ({
    options,
    value,
    groupLabel,
    onChange,
    className,
}: Props): ReactElement => (
    <DocumentSetSwitchSC
        role="group"
        aria-label={groupLabel}
        className={className}
    >
        {options.map((option) => {
            const isActive = option.value === value;

            return (
                <button
                    key={option.value}
                    type="button"
                    lang={option.lang}
                    aria-pressed={isActive}
                    className={classNames('item', { active: isActive })}
                    onClick={() => !isActive && onChange(option.value)}
                >
                    {`${option.label} (${option.count})`}
                </button>
            );
        })}
    </DocumentSetSwitchSC>
);

export default DocumentSetSwitch;
